import React from 'react'

// material ui forms
import FormLabel from '@mui/material/FormLabel'
import FormHelperText from '@mui/material/FormHelperText'
import FormControlLabel from '@mui/material/FormControlLabel'
import RadioGroup from '@mui/material/RadioGroup'
import Radio from '@mui/material/Radio'

// shared components
import FormControlWithErrorHelper from 'components/shared/FormControlWithErrorHelper'
import { useBrand } from 'components/shared/SettingsProvider'

const GenderForm = props => {
  const {
    // via EditCamperContainer:
    value, // via redux state
    formErrors, // via withFormResults

    // via CamperFormContainer:
    onChangeCamperFormField // via withEventHandlers
  } = props

  const { shortName } = useBrand()

  return (
    <FormControlWithErrorHelper
      component='fieldset'
      required
      errorsObject={formErrors}
      errorField='gender'
    >
      <FormLabel htmlFor='gender' component='legend'>
        Gender
      </FormLabel>
      <FormHelperText>
        Note: {shortName} affirms the right of all campers and staff to use
        pronouns and access bathroom facilities that align with their identity.
      </FormHelperText>
      <RadioGroup
        aria-label='gender'
        name='gender'
        id='gender'
        value={value}
        onChange={onChangeCamperFormField('gender')}
      >
        <FormControlLabel value='f' control={<Radio />} label='Female' />
        <FormControlLabel value='m' control={<Radio />} label='Male' />
        <FormControlLabel value='n' control={<Radio />} label='Non-Binary' />
        <FormControlLabel value='u' control={<Radio />} label='Unspecified' />
      </RadioGroup>
    </FormControlWithErrorHelper>
  )
}

export default GenderForm
